import ReplyIcon from '@app/assets/icons/reply.svg?react';
import CheckContainedIcon from '@app/assets/icons/check-contained.svg?react';
import InfoGrayIcon from '@app/assets/icons/info-gray.svg?react';
import YelpIcon from '@app/assets/icons/integrations/yelp.svg?react';
import GoogleLogo from '@app/assets/icons/Google.svg?react';
import FullStarIcon from '@app/assets/icons/star-full.svg?react';
import { BusinessReviews } from '@app/models/reviews';
import { getTimeAgo } from '@app/utils/utils';
import clsx from 'clsx';
import { Tooltip } from '@app/components/Tooltip/Tooltip';

const isRecentReview = (date: Date) => {
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
    return date > sevenDaysAgo;
};

export const PreviewReviewOld = ({
  active,
  review,
}: {
    active: boolean;
    review: BusinessReviews & { platform?: string };
}) => {
    return (
        <div
            className={clsx(
                'p-4 space-y-2 border-b border-b-base-ghostWhite cursor-pointer relative',
                { 'side-tab bg-brand-lightBlue4': active }
            )}
        >
            <div className="flex justify-between gap-2 items-center">
                <div className="flex items-center gap-1">
          <span>
            {review.platform === 'yelp' ? (
                <YelpIcon width={15} height={15} />
            ) : review.platform === 'google' ? (
                <GoogleLogo style={{ width: 20, height: 20 }} />
            ) : (
                <div className="p-1.5 bg-[#F6F7FA] rounded-md">
                    <InfoGrayIcon width={14} height={14} />
                </div>
            )}
          </span>
                    {isRecentReview(new Date(review.createdAt)) && (
                        <Tooltip content={review.isFeedback ? "Feedbacks from the past 7 days." : "Reviews from the past 7 days."}>
              <span className="bg-system-successLight text-system-success p-1 text-xs rounded-sm ml-1">
                New
              </span>
                        </Tooltip>
                    )}
                </div>
                <div className="flex items-center gap-1">
                    {review.platform !== 'yelp' && review.platform !== 'internal' && (
                        <>
                            {review.isFeedback && review.resolved && (
                                <Tooltip content="Resolved">
                                    <CheckContainedIcon />
                                </Tooltip>
                            )}
                            {review.reply && !(review.isFeedback && review.resolved) && (
                                <Tooltip content="Review with a response">
                                    <ReplyIcon />
                                </Tooltip>
                            )}
                        </>
                    )}
                    <span className="text-xs text-base-coolGray">
            {getTimeAgo(new Date(review.createdAt))}
          </span>
                </div>
            </div>
            <div>
                <h5 className="font-semibold text-sm flex items-center gap-2">
                    {(review.firstName || review.customer?.firstName || 'Unknown')} {(review.lastName || review.customer?.lastName || '')}
                    <div className="flex items-center gap-1">
                        <FullStarIcon
                            width={16}
                            height={16}
                            className="text-orange-400"
                        />
                        <span className="text-sm font-semibold text-gray-900">{review.rating}</span>
                    </div>
                </h5>
            </div>
            <div>
                <p className="max-h-9 overflow-hidden text-xs text-base-davyGray leading-5">
                    {review.review}
                </p>
            </div>
        </div>
    );
};
